export default "__VITE_ASSET__CeAIK4Db__"